/**
 * Agregação de TARPs por barragem (GUPM-172).
 * Alimenta o encaixe `tarpsAbertas`/`tarpsEmAnaliseRt` de
 * `computeStatusEstrutura` — TARP não baixada coloca a estrutura em
 * "Observação" (pré-ANM). TS puro.
 */
import type { TarpRecordStatus } from './status';

export interface TarpCount {
  abertas: number;
  emAnaliseRt: number;
}

export type TarpCountsPorBarragem = Record<string, TarpCount>;

/**
 * Conta TARPs ATIVAS por `damId` — as que elevam a estrutura a "Observação".
 * Não contam:
 *   - ENCERRADA (baixada): ocorrência já resolvida;
 *   - EM_ABERTURA (rascunho, GUPM-178): TARP em preparo, silenciosa e ainda não
 *     aberta — não notifica nem eleva o status da barragem (só ao confirmar).
 * CONCLUIDA_AGUARDANDO conta como aberta (ainda não baixada → Observação).
 * TARP sem barragem (`damId` null, "Ainda não identificada" — GUPM-186) não é
 * atribuível a nenhuma estrutura, então não eleva o status de barragem nenhuma.
 */
export function contarTarpsPorBarragem(
  records: readonly { damId: string | null; status: TarpRecordStatus }[],
): TarpCountsPorBarragem {
  const out: TarpCountsPorBarragem = {};
  for (const r of records) {
    if (r.status === 'ENCERRADA' || r.status === 'EM_ABERTURA') continue;
    if (!r.damId) continue; // "Ainda não identificada": sem barragem a atribuir
    const entry = (out[r.damId] ??= { abertas: 0, emAnaliseRt: 0 });
    if (r.status === 'EM_ANALISE_RT') entry.emAnaliseRt += 1;
    else entry.abertas += 1; // ABERTA + CONCLUIDA_AGUARDANDO
  }
  return out;
}

/*
 * GUPM-291: `emergenciaAtivaPorBarragem` foi REMOVIDA. Ela promovia o semáforo da
 * estrutura a EMERGENCIA na hora em que uma TARP aberta atingia o terminal
 * `paebm` (GUPM-207). O dono reverteu: declarar nível de barragem é ato do RT, e
 * a única via passa a ser o enquadramento da baixa
 * (`declaracaoAnmAtivaPorBarragem`). Uma TARP de emergência aberta é contada aqui
 * como qualquer TARP não baixada → OBSERVACAO.
 *
 * O nível da TARP em si NÃO mudou: `nivelEfetivo`/`nivelEfetivoVisivel` seguem
 * devolvendo EMERGENCIA e continuam pintando o card e definindo o prazo de 12 h.
 */
